<template>
<!--  <HelloWorld/>-->
  <StepNavigstion></StepNavigstion>

</template>

<script>
//import HelloWorld from './components/HelloWorld.vue'
import StepNavigstion from './components/StepNavigstion.vue';

export default {
  name: 'App',
  components: {
  //  HelloWorld,
    StepNavigstion
}
}
</script>

<style>
#section-image-with-text-c {
  font-family: 'museo-sans', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #5A5A5A;
}

.comdaColor{
    color: #0054a3!important;
}
.comdaColorBefore::before{
    color: #0054a3!important;
}
.comdaColorAfter::after{
    color: #0054a3!important;
}
.comdaBackgroundColor{
    background-color: #0072BC!important;
}
.comdaBackgroundColorHover:hover{
    background-color: #0072BC!important;
}
.comdaFont{
    font-family: 'Oswald', Verdana, Arial, sans-serif!important;
}

.mlpColor{
    color: #009444!important;
}
.mlpColorBefore::before{
    color: #009444!important;
}
.mlpColorAfter::after{
    color: #009444!important;
}
.mlpBackgroundColor{
    background-color: #009444!important;
}
.mlpBackgroundColorHover:hover{
    background-color: #009444!important;
}
.mlpFont{
    font-family: 'museo-sans', sans-serif!important;
}

/*
.container-bundle-customize {
    display: flex;
    flex-direction: row;
  }
  .container-bundle-customize > .column {
    width: 47%;
  }

  .page_type.calendar-bundle-custom .column {
    display: flex;
    width: 100%;
  } */
</style>
